import React, { Component } from 'react'
import { Form, Input, Button, message, Icon } from 'antd';
import instance from '../../service/index'
import './login.less'
const FormItem = Form.Item
class Login extends Component {
	constructor() {
		super()
		this.state = {
			imgUrl: '',
			authCodeToken: '',
			code: '',
			mobile: '',
			password: '',
		}
	}
	componentDidMount() {
		this.getImgCaptcha()
	}
	getImgCaptcha() {
		instance.post('/capchaRestController/captcha').then(res => {
			if (res.data.code === '200') {
				this.setState({
					imgUrl: res.data.data.img,
					authCodeToken: res.data.data.authCodeToken
				})
			}
		})
	}
	handleSubmit = e => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				instance.post('/user/login', {
					mobile: values.mobile,
					password: values.password,
					code: values.authCode,
					authCodeToken: this.state.authCodeToken
				})
					.then(res => {
						if (res.data.code !== '200') {
							this.getImgCaptcha()
							return message.error(res.data.msg)
						}
						if (res.data.code === '200') {
							let user = JSON.stringify(res.data.data.admin)
							localStorage.setItem('user', user)
							localStorage.setItem('token', res.data.data.token)
							this.props.history.replace('/sysHome')
						}
					})
			}
		});
	};
	render() {
		const { getFieldDecorator } = this.props.form;
		return (
			<div className="p-login">
				<div className="box">
					<div className="left"></div>
					<div className="right">
						<h1>芯源学习站管理后台</h1>
						<p className="fontP">OA账号登录</p>
						<Form
							onSubmit={this.handleSubmit}
						>
							<FormItem>
								{getFieldDecorator('mobile', {
									rules: [{ required: true, message: '请输入用户名!' }],
								})(
									<Input className='login-input' prefix={<Icon type="user"  style={{ color: 'rgba(0,0,0,.5)' }} />}  placeholder="请输入用户名" />
								)}
							</FormItem>
							<FormItem>
								{getFieldDecorator('password', {
									rules: [{ required: true, message: '请输入密码!' }],
								})(
									<Input className='login-input' prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.5)' }}/>} type="password"
										placeholder='请输入密码' />
								)}
							</FormItem>
							<FormItem>
								{getFieldDecorator('authCode', {
									rules: [{ required: true, message: '请输入验证码!' }],
								})(
									<div className="code">
										<Input className='login-input' prefix={<Icon type="safety" style={{ color: 'rgba(0,0,0,.5)' }} />} placeholder='请输入验证码' />
										<img src={this.state.imgUrl} alt="" onClick={() => { this.getImgCaptcha() }} />
									</div>
								)}
							</FormItem>

							<Form.Item>
								<Button className="login-ok" type="primary" htmlType="submit">
									确认登录
        						</Button>
							</Form.Item>
						</Form>
					</div>
				</div>
			</div>
		)
	}
}

export default Form.create()(Login)
